export const persistConstants = {
  blacklistedKeys: [
    "columns",
    "configuration",
    "datagridRows",
    "dependedRelation",
    "error",
    "filtering",
    "form",
    "loading",
    "masterDetail",
    "theme",
  ],
};
